// TicketWin.jsx
import React from 'react';
import logo from "../assets/logo_ticket_win.png";
import Header from './landing/Header';
import HeroHome from './landing/Hero';

const Landing = () => {
  return (
    <div className="bg-gray-100 min-h-screen flex flex-col items-center" >
     {/* <Header /> */}
     <footer className="bg-blue-600 w-full p-4">
        <p className="text-white text-center">¡Con TicketWin, todos tienen la oportunidad de ganar!</p>
      </footer>
     <HeroHome />
    </div>
  );
};

export default Landing;
